import { call, select } from 'redux-saga/effects';
import LogService from 'services/LogService';
import { buildErrorObject } from 'redux/sagas/sagaHelpers/userHelpers';
import { _sendRequest } from 'redux/sagas/sagaHelpers/generalHelpers';
import { getUserProfileAndSettings } from 'redux/sagas/selectors';

async function log(message) {
  try {
    return await _sendRequest(message, LogService.logInfo);
  } catch (error) {
    return buildErrorObject(error);
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* logSaga(action) {
  const userProfileAndSettings = yield select(getUserProfileAndSettings);
  const lotId = userProfileAndSettings.activeLotId;
  yield call(log, `${lotId}-${action.payload}`);
}
